// extracted by mini-css-extract-plugin
export default {"button":"Button_button__vTjON","submit":"Button_submit__yoyIv","slide":"Button_slide__HD15I","left":"Button_left__Vq8YH","disabled":"Button_disabled__49NY7"};